<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <!-- <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol> -->
    <CCard style="margin-top: 20px" v-else>
      <CCardBody v-if="table1">
        <DatePicker
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
          style="float: left"
        ></DatePicker>
        &nbsp;&nbsp;&nbsp;
        <JsonCSV
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData6"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot) </JsonCSV
        >&nbsp;&nbsp;

        <!-- <CSelect
        horizontal
        :options="options"
        placeholder="Please select"
        v-model="fielterdata"
        @change="onChange($event)"
        style="width: 300px; float: right; margin-left: 50px; margin-top: 6px"
      /> -->
        <CButton
          v-if="filterbtn"
          color="success"
          class="mb-2"
          download="coreui-table-data.csv"
          target="_blank"
          style="margin-left: 50px"
          @click="refresh()"
        >
          Go to all data
        </CButton>
        <CDataTable
          :items="tableData6"
          :fields="fields"
          column-filter
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
      </CCardBody>
      <CCardBody v-if="table2">
        <DatePicker
          v-model="value1"
          type="date"
          range
          placeholder="Select date range"
          style="float: left"
        ></DatePicker>
        &nbsp;&nbsp;&nbsp;
        <JsonCSV
          color="primary"
          class="btn btn-default mb-2 clr"
          :data="tableData6"
          name="rage_capture-list.csv"
        >
          Download CSV (This is a slot) </JsonCSV
        >&nbsp;&nbsp;

        <!-- <CSelect
        horizontal
        :options="options"
        placeholder="Please select"
        v-model="fielterdata"
        @change="onChange($event)"
        style="width: 300px; float: right; margin-left: 50px; margin-top: 6px"
      /> -->
        <CButton
          v-if="filterbtn"
          color="success"
          class="mb-2"
          download="coreui-table-data.csv"
          target="_blank"
          style="margin-left: 50px"
          @click="refresh()"
        >
          Go to all data
        </CButton>
        <CDataTable
          :items="tableData"
          :fields="fields"
          column-filter
          :items-per-page="10"
          hover
          sorter
          pagination
        >
        </CDataTable>
      </CCardBody>
      <CModal title="Add Token limit" :show.sync="myModal">
        <CInput placeholder="Enter coin" type="number" v-model="stakeLimit" />
        <span v-if="filetext" style="color: red">please enter coin</span>
        <template #footer>
          <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
          <CButton color="success" @click="updatetokenlimit()">add</CButton>
        </template>
      </CModal>
    </CCard>
  </div>
</template>

<script>
import axios from "axios";
import usersData from "../users/UsersData";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import JsonCSV from "vue-json-csv";
const db = firebase.firestore();
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "DownloadTable",
  components: {
    JsonCSV,
    DatePicker,
  },
  data() {
    return {
      table1: true,
      table2: false,
      promocodedata: [],
      value1: [],
      Spinner: true,
      grapdata: "Rage",
      filterbtn: false,
      filetext: false,
      itemEmail: "",
      myModal: false,
      usersData,
      currentItems: [],
      grapdata: "",
      stakeLimit: 0,
      fielterdata: "",
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      options: [],
      promocodedata: [],
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        {
          label: "Time",
          key: "time",
          sortable: true,
        },
        {
          label: "firstName",
          key: "firstName",
          sortable: true,
        },
        {
          label: "email",
          key: "email",
          sortable: true,
        },
        // {
        //   label: "Tokencount",
        //   key: "count",
        //   sortable: true,
        // },
        {
          label: "promocode",
          key: "refferalcode",
          sortable: true,
        },
        {
          label: "Promoemail",
          key: "Promoemail",
          sortable: true,
        },
      ],
      details: [],
      collapseDuration: 0,
      conditionLimit: 0,
    };
  },
  computed: {
    csvContent() {
      return this.currentItems
        .map((item) => Object.values(item).join(","))
        .join("\n");
    },
    csvCode() {
      return (
        "data:text/csv;charset=utf-8,SEP=,%0A" +
        encodeURIComponent(this.csvContent)
      );
    },
  },
  watch: {
    value1() {
        this.promocodedata = [];
          this.tableData = [];

      var res = new Date(this.value1[1]);
      res.setDate(res.getDate() + 1);

      let v1 = firebase.firestore.Timestamp.fromDate(new Date(this.value1[0]));
      let v2 = firebase.firestore.Timestamp.fromDate(new Date(res));

      db.collection("users")

        .where("created", ">=", v1)
        .where("created", "<=", v2)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
        
          querySnapshot.docs.map((doc) => {
            if (doc.data().promocode != "") {
              let backenddate =
                doc.data().created != null
                  ? moment(doc.data().created.seconds * 1000).format(
                      "DD-MMM-YYYY"
                    )
                  : "";
              let backendtime =
                doc.data().created != null
                  ? moment(doc.data().created.seconds * 1000).format(
                      "h:mm:ss A"
                    )
                  : "";

              this.promocodedata.push({
                firstName: doc.data().firstName,
                lastname: doc.data().lastName,
                email: doc.data().email,
                promocode: doc.data().promocode,
                country: doc.data().country,
                backenddate: backenddate,
                backendtime: backendtime,
              });
            }
          });

          console.log("promocodedata", this.promocodedata);
          this.table2 = true;
          this.table1 = false;
          this.promocodedata.forEach((users) => {
            db.collection("mycode")

              .where("userid", "==", users.promocode)
              // .where("promocode", "!=", '')
              .get()
              .then((snapshot) => {
                snapshot.docs.map((doc) => {
                  // console.log("prefferalcode entered", doc.data())

                  this.tableData.push({
                    firstName: users.firstName,
                    lastname: users.lastname,
                    email: users.email,
                    date: users.backenddate,
                    time: users.backendtime,
                    country: users.country,
                    // promocode: doc.data().promocode,
                    refferalcode: users.promocode,
                    Promoemail: doc.data().email,
                  });
                });
                // console.log("Watch final console", this.tableData);
                // return res.json({ status: 200, Result: tableData2, Message: "success" });
              });
          });
          console.log("Watch final console", this.tableData);
        });
    },
  },
  methods: {
    getpromocode() {
      this.Spinner = true;
      console.log("data get started");
      // APIService.getpromocode().then((res) => {
      // axios
      // .get(
      //   "https://us-central1-token-geomine.cloudfunctions.net/adminApi/promocodedata"
      // )
      // .then((res) => {
      axios
        .get(
          "https://us-central1-token-geomine.cloudfunctions.net/adminApi/promocodedata"
        )
        .then((res) => {
          if (res.status == 200) {
            this.Spinner = false;
            console.log("came data", res);
            console.log("came data", res.data.Result);
            this.tableData6 = res.data.Result;
          }
          // console.log("tableData2", this.tableData6);
        });
    },
    promocodehere() {
      this.Spinner = false;
      // console.log("entered");
      this.promocodedata = [];
      this.tableData6 = [];
      var startOfToday = new Date();
      startOfToday.setHours(0, 0, 0, 0);
      var endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      // this.table1=true
      // this.table2=false
      db.collection("users")
        .where("created", ">=", startOfToday)
        .where("created", "<=", endOfToday)
        .orderBy("created", "desc")
        .get()
        .then((querySnapshot) => {
          if (!querySnapshot.empty) {
             if (doc.data().promocode != "") {
            querySnapshot.docs.map((doc) => {
              let backenddate =
                doc.data().created != null
                  ? moment(doc.data().created.seconds * 1000).format(
                      "DD-MMM-YYYY"
                    )
                  : "";
              let backendtime =
                doc.data().created != null
                  ? moment(doc.data().created.seconds * 1000).format(
                      "h:mm:ss A"
                    )
                  : "";
              // console.log("second-doc", doc.data())
             
                this.promocodedata.push({
                  firstName: doc.data().firstName,
                  lastname: doc.data().lastName,
                  email: doc.data().email,
                  promocode: doc.data().promocode,
                  country: doc.data().country,
                  backenddate: backenddate,
                  backendtime: backendtime,
                });
           
            });
             }
          }
          console.log("promocodedata", this.promocodedata);
          this.promocodedata.forEach((users) => {
            db.collection("mycode")

              .where("userid", "==", users.promocode)
              .get()
              .then((snapshot) => {
                if (!snapshot.empty) {
                  snapshot.docs.map((doc) => {
                    // console.log("prefferalcode entered", doc.data())

                    this.tableData6.push({
                      firstName: users.firstName,
                      lastname: users.lastname,
                      email: users.email,
                      date: users.backenddate,
                      time: users.backendtime,
                      country: users.country,
                      // promocode: doc.data().promocode,
                      refferalcode: users.promocode,
                      Promoemail: doc.data().email,
                    });
                  });
                  console.log("final console", this.tableData6);
                } else {
                }
              });
          });
        });
    },

    assignscaptureData(doc) {
      // let emaildata = this.tableData4.filter((a) => {
      //   return a.email == doc.id;
      // });
      // console.log("emaildata",emaildata[0].ethAddress)
      let smallDocument = {
        id: doc.id,
        TRAGE: doc.data()[this.grapdata].length,
        // Ethereum: emaildata[0].ethAddress,
      };
      return smallDocument;
    },
    refresh() {
      window.location.reload();
    },
    assignpromocode(doc) {
      let smallDocument = {
        id: doc.id,
        promocode: doc.data().promocode,
      };
      return smallDocument;
    },

    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("promocode")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.tableData.push(this.assignpromocode(doc));
            // console.log(" this.tableData", this.tableData);
            let value = this.tableData.map((n) => {
              return n.promocode;
            });
            // console.log("value", value);
            this.options = value;
          });
          this.loading = false;
        });
    },
    allpromocode() {
      this.tableData2 = [];
      db.collection("users")
        .where("promocode", "!=", null)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // console.log("doc.id", doc.id);

            let backenddate =
              doc.data().created != null
                ? moment(doc.data().created.seconds * 1000).format(
                    "DD-MMM-YYYY"
                  )
                : "";
            let backendtime =
              doc.data().created != null
                ? moment(doc.data().created.seconds * 1000).format("h:mm:ss A")
                : "";

            let emaildata = this.promocodedata.filter((a) => {
              return a.puserid == doc.data().promocode;
            });

            if (doc.data().promocode != "null" && doc.data().promocode != "") {
              (this.Spinner = false),
                this.tableData2.push({
                  name: doc.data().firstName,
                  email: doc.data().email,

                  country: doc.data().country,
                  date: backenddate,
                  time: backendtime,
                  promocode: doc.data().promocode,
                  userid: doc.data().userid,
                  Promoemail:
                    emaildata[0] != undefined ? emaildata[0].pemail : null,
                  // count: tokencount[0].Trage != undefined ? tokencount[0].Trage : 0
                });
            }
            // console.log("data", doc.data());
          });
        });
    },

    onChange(event) {
      // onChange() {
      this.tableData2 = [];
      this.grapdata = event.target.value;
      // console.log("grapdata", this.grapdata.toLowerCase());
      db.collection("users")
        .where("promocode", "!=", null)
        .where("promocode", "==", this.grapdata.toLowerCase())
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate =
              doc.data().created != null
                ? moment(doc.data().created.seconds * 1000).format(
                    "DD-MMM-YYYY"
                  )
                : "";
            let backendtime =
              doc.data().created != null
                ? moment(doc.data().created.seconds * 1000).format("h:mm:ss A")
                : "";

            this.tableData2.push({
              id: doc.id,
              name: doc.data().firstName,
              email: doc.data().email,
              promocode: doc.data().promocode,
              country: doc.data().country,
              date: backenddate,
              time: backendtime,
            });
          });
          this.filterbtn = true;
        });
    },
    getpromolist() {
      db.collection("mycode")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.promocodedata.push({
              pid: doc.id,
              pemail: doc.data().email,
              prefferalcode: doc.data().refferalcode,
              puserid: doc.data().userid,
            });
          });
        });
    },
  },
  created() {
    this.promocodehere();
    // this.getpromocode();
    // this.getpromolist();
    // this.allpromocode();
    // this.onCapture();
  },
};
</script>
<style >
.clr {
  color: #fff !important;
  background-color: #321fdb !important;
}
</style>